/** LightOccluder2D registration: the parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseLightOccluder2D } from './parser';
const lightOccluder2DRegistration = {
    typeName: 'LightOccluder2D',
    parser: parseLightOccluder2D,
};
nodeRegistry.register(lightOccluder2DRegistration);
//# sourceMappingURL=index.js.map